module.exports = __webpack_public_path__ + "static/media/intelliprice-logo-grey.6dc37e4b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/intelliprice-logo-grey.png
 ** module id = 781
 ** module chunks = 0
 **/